// Transform #{alphaHex}{colorHex} to #{colorHex}{alphaHex}
export const transformColorFormat = (hexColor) => {
  if (!hexColor || hexColor.length !== 9) {
    return hexColor;
  }
  const alphaHex = hexColor.slice(1, 3);
  const colorHex = hexColor.slice(3);
  return `#${colorHex}${alphaHex}`;
};
  
// Combine an alpha value and a color hex code into a single hex string.
export const combineAlphaWithColor = (colorHex) => {
  // Remove the hash at the start if it's there
  if (colorHex.startsWith('#')) {
    colorHex = colorHex.substring(1);
  }
  
  let alphaHex, color;
  
  if (colorHex.length === 8) {
    // Color includes opacity
    alphaHex = colorHex.substring(6, 8);
    color = colorHex.substring(0, 6);
  } else if (colorHex.length === 6) {
    // Color without opacity
    return `#FF${colorHex}`;
  } else if (colorHex.length === 3) {
    // Handle shorthand hex color, e.g., #FFF
    alphaHex = 'FF'; // Default opacity
    color = colorHex.split('').map(char => char + char).join('');
    return `#${color}`; // Return expanded shorthand without opacity
  } else {
    throw new Error('Invalid color hex code');
  }

  // Ensure color hex code is valid
  if (!/^([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color)) {
    throw new Error('Invalid color hex code');
  }

  // Add the alpha value to the front if it's not '11' or 'FF'
  if (alphaHex && alphaHex !== '11' && alphaHex !== 'FF') {
    return `#${alphaHex}${color}`;
  } else {
    return `#${alphaHex}${color}`; //changed 200924
  }
};

export const getNestedProperty = (obj, path) => {
  return path.split('.').reduce((obj, key) => obj && obj[key], obj);
};

export const setNestedProperty = (obj, path, value) => {
  const keys = path.split('.');
  const lastKey = keys.pop();
  
  // Traverse the object without creating new properties
  const lastObj = keys.reduce((acc, key) => {
    if (acc[key] && typeof acc[key] === 'object') {
      return acc[key];
    } else {
      // If any intermediate property does not exist or is not an object, exit early
      return undefined;
    }
  }, obj);

  // Only set the value if the last object is valid and the lastKey exists
  if (lastObj !== undefined && lastKey in lastObj) {
    lastObj[lastKey] = value;
  } else {
    console.warn(`Cannot set property ${path}: path does not exist.`);
  }
};

export const ensureHexColor = (color) => {
  if (!color) return "#FFFFFF";
  if (typeof color !== 'string') {
    return "#FFFFFF";
  }
  return color.startsWith("#") ? color : `#${color}`;
};


export const extractCards = (data: any[]): string[] => {
  const cardSet = new Set<string>();

  data.forEach(item => {
    cardSet.add(item.card);
  });

  return Array.from(cardSet);
};

export const hexToRgba = (hex) => {
  let r = 0, g = 0, b = 0, a = 1;

  if (hex.length === 9) {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
    a = parseInt(hex.slice(7, 9), 16) / 255;
  } else if (hex.length === 7) {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
  }

  return { r, g, b, a };
};

export const rgbaToHex = (r, g, b, a) => {
  const toHex = (num) => num.toString(16).padStart(2, '0');
  const alpha = Math.round(a * 255); // Convert alpha to a 0-255 scale
  return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(alpha)}`;
};
